import { Tab, Tabs } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import styled from "styled-components";

export const ContainerRefreshQrCode = styled.div`
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fbfbfd;
  border: 1px dashed #616161;
  padding: 24px;
  flex-direction: column;
  transition: background 0.3s;
  cursor: pointer;
  &:hover {
    background: #f0f1f3;
  }
`;

export const TabStyled = styled(Tab)`
  text-transform: none;
  color: #424242;
  font-weight: 500;
  &.Mui-selected {
    color: #0036b3;
    border-bottom: 2px solid #0036b3;
  }
`;

export const TabsStyled = styled(Tabs)`
  .MuiTabs-indicator {
    display: flex;
    justify-content: center;
    height: 2px;
    background-color: transparent;
    max-width: 40px;
    width: 100%;
  }
`;

export const StyledDatagrid = styled(DataGrid)`
  border: 0px !important;

  .MuiDataGrid-root {
    border: 0px !important;
  }
  .MuiDataGrid-columnsContainer {
    background: #f5f5f5;
    align-items: center;
    padding-top: 10px;
  }
`;
